import React, { useState, useRef, useEffect, ReactNode } from 'react';

export const NonClosableTooltip: React.FC<{
  children: ReactNode;
  content: ReactNode;
}> = ({ children, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  // Открыть тултип
  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  // Закрыть тултип
  const handleClose = () => {
    setIsOpen(false);
  };

  // Закрытие при клике вне
  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (e: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(e.target as Node) &&
        triggerRef.current &&
        !triggerRef.current.contains(e.target as Node)
      ) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen]);

  // ESC для закрытия
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        handleClose();
      }
    };

    document.addEventListener('keydown', handleEsc);

    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen]);

  // Рассчитать позицию
  const getTooltipStyle = (): React.CSSProperties => {
    if (!triggerRef.current) return {};

    return {
      position: 'absolute',
      top: 30,
      left: 0,
      color: 'rgba(11, 11, 11, 0.88)',
      width: '364px',
      zIndex: 1000,
      transform: 'none',
      padding: '10px 16px 12px',
      background: '#FFFFFF',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
    };
  };

  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <div ref={triggerRef} onClick={handleOpen} style={{ cursor: 'pointer', display: 'inline-block' }}>
        {children}
      </div>

      {isOpen && (
        <div ref={tooltipRef} style={getTooltipStyle()} onClick={e => e.stopPropagation()}>
          <div style={{ position: 'relative' }}>
            <div>{content}</div>
          </div>
        </div>
      )}
    </div>
  );
};
